// Auto-generated skeleton for Email

export const Email: Api.Email = {
  id: 0,
  user_id: 0,
  from: '',
  from_name: null,
  cc: [],
  bcc: [],
  to: [],
  subject: null,
  text: null,
  html: null,
  date: '',
  document_containers: [],
  created: null,
  updated: null,
};

